import React from 'react';
import moment from 'moment';
import { Item, Feed, Segment, Label, Input, Button } from 'semantic-ui-react';

const Comments = ({
  passengerTicket,
  passengerComment,
  comments,
  onInputChange,
  onAddComment
}) => {
  const {
    passengerFirstName,
    passengerLastName,
    widgetCommentFromPax
  } = passengerTicket || '';
  return (
    <Item>
      <Item.Content>
        <Item.Header>Comments</Item.Header>
        <Item.Meta>
          <Segment basic>
            <Input onChange={onInputChange} style={{ marginRight: '0px' }} />
            <Button color="blue" onClick={onAddComment} content="Add" />
          </Segment>
        </Item.Meta>
        <Feed>
          {comments.map(comment => (
            <Feed.Event key={comment.id}>
              <Feed.Content>
                <Feed.Summary>
                  <Feed.User>
                    {comment.user && comment.user.name}{' '}
                    {comment.user && comment.user.surname}
                  </Feed.User>
                  <Feed.Date>
                    {moment(comment.createdAt).format('DD/MM/YYYY')}
                  </Feed.Date>
                </Feed.Summary>
                <Feed.Extra text>{comment.content}</Feed.Extra>
              </Feed.Content>
            </Feed.Event>
          ))}
          {passengerComment && (
            <Feed.Event key={-1}>
              <Feed.Content>
                <Label>
                  <Feed.Summary>
                    <Feed.User
                    >{`PAX: ${passengerFirstName} ${passengerLastName}`}</Feed.User>
                    <Feed.Date>comment from traveler form</Feed.Date>
                  </Feed.Summary>
                  <Feed.Extra text>{passengerComment}</Feed.Extra>
                </Label>
              </Feed.Content>
            </Feed.Event>
          )}
          {widgetCommentFromPax && (
            <Feed.Event key={-2}>
              <Feed.Content>
                <Label>
                  <Feed.Summary>
                    <Feed.User
                    >{`PAX: ${passengerFirstName} ${passengerLastName}`}</Feed.User>
                    <Feed.Date>comment from widget</Feed.Date>
                  </Feed.Summary>
                  <Feed.Extra text>{widgetCommentFromPax}</Feed.Extra>
                </Label>
              </Feed.Content>
            </Feed.Event>
          )}
        </Feed>
      </Item.Content>
    </Item>
  );
};

export default Comments;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Comments/View.js